import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Cliente } from 'src/app/model/cliente.model';
import { AlertService } from 'src/app/service/alert.service';
import { ClientesService } from 'src/app/service/clientes.service';
import { RelatoriosService } from 'src/app/service/relatorios.service';

@Component({
  selector: 'app-dialog-acessos-premocenter',
  templateUrl: './dialog-acessos-premocenter.component.html',
  styleUrls: ['./dialog-acessos-premocenter.component.css']
})
export class DialogAcessosPremocenterComponent implements OnInit, OnDestroy
{
  clientes: Cliente[] = [];
  idsClientes: number[] = [];
  clientesSelecionados: number[] = [];
  @ViewChild('opcaoTodosClientes') opcaoTodosClientes!: MatOption;
  formulario!: FormGroup;
  dataFinalDeveSerMaiorQueInicial = (formulario: FormGroup): ValidationErrors | null =>
  {
    var dataInicialFormulario: string = formulario.get('dataInicial')?.value ?? '';
    var dataFinalFormulario: string = formulario.get('dataFinal')?.value ?? '';
    var dataInicial: Date = new Date(dataInicialFormulario);
    var dataFinal: Date = new Date(dataFinalFormulario);

    if ((dataInicialFormulario == '' || dataFinalFormulario == '') || dataInicial < dataFinal) {
      return null;
    }

    return { dataFinalInvalida: true };
  }
  alertas: any = {
    buscando_acessos: 'Buscando acessos...',
    nenhum_acesso_encontrado: 'Nenhum acesso encontrado no período filtrado.',
    baixando_arquivo: 'Baixando arquivo...',
    download_sucesso: 'Download do arquivo realizado com sucesso!',
    formulario_invalido: 'Dados de busca inválidos.',
    erro_gerar_relatorio: { titulo: 'Erro ao gerar relatório', mensagem: 'Caso o erro persista, contate o suporte.' },
  };
  requestListarClientes!: Subscription;

  constructor(
    private dialogRef: MatDialogRef<DialogAcessosPremocenterComponent>,
    private relatoriosService: RelatoriosService,
    private clientesService: ClientesService,
    private formBuilder: FormBuilder,
    private alertService: AlertService
  )
  {
    this.formulario = this.formBuilder.group({
      dataInicial: new FormControl(null, Validators.required),
      dataFinal: new FormControl(null, Validators.required),
      idsClientes: new FormControl(null, Validators.required)
    },
      {
        validators: [this.dataFinalDeveSerMaiorQueInicial]
      });
  }

  ngOnInit(): void
  {
    this.buscarClientes();
    this.dialogRef.afterClosed().subscribe(() => { this.cancelarRequests(); });
  }

  ngOnDestroy(): void
  {
    this.cancelarRequests();
  }

  fecharDialog(): void
  {
    this.dialogRef.close();
  }

  buscarClientes(): void
  {
    this.requestListarClientes = this.clientesService.listarServiceClientes().subscribe((clientes: Cliente[]) =>
    {
      this.clientes = clientes;
      this.idsClientes = clientes.map((cliente: Cliente) => cliente.sr_id);
    });
  }

  baixarRelatorio(): void
  {
    if (this.formulario.invalid) {
      this.alertService.error(this.alertas.formulario_invalido)
    } else {
      this.alertService.loading(this.alertas.buscando_acessos)

      const dataInicial: string = this.formulario.get('dataInicial')?.value;
      const dataFinal: string = this.formulario.get('dataFinal')?.value;
      const clientes: string = this.clientesSelecionados.join(',');

      this.relatoriosService.buscarRelatorioAcessosPremocenter(dataInicial, dataFinal, clientes).subscribe((relatorio: string | null) =>
      {
        if (relatorio !== null) {
          this.processarDownloadRelatorioSucesso(relatorio)
        } else {
          this.alertService.info(this.alertas.nenhum_acesso_encontrado)
        }
      },
        () =>
        {
          this.alertService.dismiss();
          this.alertService.error(this.alertas.erro_gerar_relatorio.mensagem, this.alertas.erro_gerar_relatorio.titulo)
        });
    }
  }

  processarDownloadRelatorioSucesso(relatorio: string): void
  {
    this.alertService.updateLoadingMessage(this.alertas.baixando_arquivo);
    this.gerarEBaixarArquivoCsv(relatorio);
    this.alertService.dismiss();
    this.alertService.success(this.alertas.download_sucesso)
  }

  gerarEBaixarArquivoCsv(relatorio: string): void
  {
    relatorio += '\ufeff';
    const blob = new Blob([relatorio], { type: 'text/csv;charset=utf-8' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'relatorio_acessos_premocenter';
    link.click();
  }

  formatarData(data: string): string
  {
    return data.replace('T', ' ') + ':00';
  }

  selecionarTodosClientes(opcaoTodosClientes: MatOption): void
  {
    this.clientesSelecionados = opcaoTodosClientes.selected ? this.clientesSelecionados.concat(this.idsClientes) : [];
  }

  selecionarCliente(idCliente: number): void
  {
    var idsSelecionados: number[] = this.idsSelecionadosQueExistem();
    var todosClientesSelecionados: boolean = idsSelecionados.length == this.idsClientes.length;

    if (this.clientesSelecionados.includes(idCliente) && todosClientesSelecionados) {
      this.opcaoTodosClientes.select()
    } else {
      this.opcaoTodosClientes.deselect()
    }
  }

  idsSelecionadosQueExistem(): number[]
  {
    return this.clientesSelecionados.filter((id: number) => this.idsClientes.includes(id));
  }

  formularioTemErroData(): boolean
  {
    return this.formulario.hasError('dataFinalInvalida') && this.formulario.controls['dataFinal'].touched;
  }

  cancelarRequests(): void
  {
    if (this.requestListarClientes) {
      this.requestListarClientes.unsubscribe();
    }
  }
}